export const signOut = async ({ callbackUrl = "/login" }: { callbackUrl?: string }) => {
  const response = await fetch("/api/sign-out/", {
    method: "POST",
  })
  if (response.ok) {
    window.location.href = callbackUrl
  }
}
